import { Component } from "react";
import { withRouter } from 'react-router-dom';
import { getEnv, loadedInIframe } from "../../helpers/GeneralHelper";
import { connect } from "react-redux";
import {isGdprRegion, isInHub} from "../../helpers/AppHelper";

class CookieScripts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            appWasLoaded: false,
            appLoadError: null,
            scriptsLoaded: false
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.appWasLoaded !== prevState.appWasLoaded) {
            return ({appWasLoaded: nextProps.appWasLoaded})
        }
        if (nextProps.appLoadError !== prevState.appLoadError) {
            return ({appLoadError: nextProps.appLoadError})
        }

        return null;
    }

    componentDidMount() {
        if (this.shouldWeLoadCookieScripts() === true) {
            if (loadedInIframe() || isInHub() === false) {
                // we let the product or the website handle the cookie stuff
            } else {
                window.gdprRequired = false;
                this.insertScriptInHead();
            }
        } else {
            // this is the non-gdpr side, we need to handle things
            this.proceedWithoutCookieBar();
            if (window.OptanonWrapper && "function" === typeof window.OptanonWrapper) {
                window.gdprRequired = true;
                window.OptanonWrapper();
            }
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) { }
    getCookie = (name) => {
        let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : undefined;
    }
    insertScriptInHead = () => {
        const script = document.createElement("script"), env = getEnv();
        script.src = this.getScriptSrc(env);
        script.async = true;
        document.head.appendChild(script);

        this.setState({scriptsLoaded: true});
    };
    getScriptSrc = (env) => {
        let scriptName = 'eu_shared.js', scriptSrc = '';

        switch(env) {
            case 'test':
            case 'development':
                scriptSrc = 'https://d3tvj3lw2y3r4c.cloudfront.net/webpage/test/js/cookies/' + scriptName;
                // scriptSrc = '/development_' + scriptName;
                break;
            default:
                scriptSrc = 'https://d3tvj3lw2y3r4c.cloudfront.net/webpage/prod3/js/cookies/' + scriptName;
        }

        return scriptSrc;
    };
    shouldWeLoadCookieScripts = () => {
        return (
            this.state.appWasLoaded === true &&
            typeof window.jQuery !== 'undefined' &&
            this.state.scriptsLoaded === false &&
            isGdprRegion() === true
        );
    };
    proceedWithoutCookieBar = () => {
        window.dataLayer = window.dataLayer || [];
        // we set the Optanon active groups
        window.OptanonActiveGroups = ",1,2,3,4,";
        window.dataLayer.push({OptanonActiveGroups: window.OptanonActiveGroups});

        // we transform text/plain script tags in text/javascript tags
        if (typeof window.jQuery !== 'undefined') {
            window.jQuery("script").each(function() {
                if (window.jQuery(this).attr("type") && "text/plain" === window.jQuery(this).attr("type").toLowerCase() && window.jQuery(this).attr("class") && window.jQuery(this).attr("class").toLowerCase().match(/optanon-category-[0-9]+($|\s)/)) {
                    window.jQuery(this).attr("type", "text/javascript");
                }
            });

            // we set the OptanonAlertBoxClosed cookie
            let setCookie, getCookie;
            if (typeof window.jQuery.cookie !== 'undefined') {
                getCookie = setCookie = window.jQuery.cookie;
            } else if (typeof window.Cookies !== 'undefined') {
                getCookie = window.Cookies.get;
                setCookie = window.Cookies.set;
            } else {
                getCookie = this.getCookie;
                setCookie = (name, value, options) => {
                    let dateObj = new Date();
                    if (options.expires) {
                        dateObj.setTime(dateObj.getTime() + (options.expires * 86400000));
                    }

                    document.cookie = name + "=" + escape (value) +
                        ((options.expires) ? "; expires=" + dateObj.toUTCString() : "") +
                        ((options.path) ? "; path=" + options.path : "") +
                        ((options.domain) ? "; domain=" + options.domain : "") +
                        ((options.secure) ? "; secure" : "");
                }
            }
            let OptanonAlertBoxClosedCookie = getCookie('OptanonAlertBoxClosed');
            if (OptanonAlertBoxClosedCookie === undefined) {
                let old_cookie_value = getCookie('wv_usr_ll');
                let new_cookie_value = window.location.pathname.replace(/\/$/, "");

                if (old_cookie_value !== undefined && old_cookie_value !== new_cookie_value) {
                    // cookie bar needs to get closed for this user
                    setCookie('wv_usr_ll', new_cookie_value, {
                        expires: -1,
                        path: '/',
                        domain: '.wevideo.com',
                        secure: true
                    });

                    setCookie('OptanonAlertBoxClosed', new Date().toISOString(), {
                        expires: 365,
                        path: '/',
                        domain: '.wevideo.com',
                        secure: true
                    });
                } else {
                    setCookie('wv_usr_ll', new_cookie_value, {
                        expires: 365,
                        path: '/',
                        domain: '.wevideo.com',
                        secure: true
                    });
                }
            }
        }
    };
    render() {
        return null;
    }
}

const mapStateToProps = (state) => {
    return {
        appWasLoaded: state.app.appLoaded,
        appLoadError: state.app.error
    }
};

export default withRouter(connect(mapStateToProps, null)(CookieScripts));
